import React from 'react';
import Section from './shared/Section';
import { Paragraph } from './shared/Basics.js';



const Registry = () => {
  return (
    <Section title='Registry' id='registry'>
      <Paragraph>We do not have a wedding registry. Your love and presence at our wedding is the greatest gift of all.</Paragraph>
      <Paragraph>If it is your wish to bless us with a gift, you can give us a gift of money to help start our new chapter of life. We greatly appreciate it!</Paragraph>
    </Section>
  );
}

export default Registry;
